import { useNavigate } from 'react-router-dom';
import { getUtmParams } from '../utils/utm';

/**
 * Hook customizado que preserva UTMs ao navegar
 * Usa a mesma API do useNavigate mas adiciona UTMs automaticamente
 * 
 * @returns {function} Função de navegação que preserva UTMs
 */
export function useNavigateWithUtm() {
  const navigate = useNavigate();

  return (to, options) => {
    const utmParams = getUtmParams();
    const utmString = utmParams.toString();
    
    // Se 'to' é uma string (path)
    if (typeof to === 'string') {
      const separator = to.includes('?') ? '&' : '?';
      const pathWithUtm = utmString ? `${to}${separator}${utmString}` : to;
      return navigate(pathWithUtm, options);
    }
    
    // Se 'to' é um objeto (location)
    if (typeof to === 'object' && to !== null) {
      const search = to.search || '';
      const separator = search ? '&' : '?';
      const searchWithUtm = utmString ? `${search}${separator}${utmString}` : search;
      return navigate({ ...to, search: searchWithUtm }, options);
    }
    
    // Fallback
    return navigate(to, options);
  };
}
